/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interaccountingemail22Inputs */

const en__field_interaccountingemail22 = /** @type {(inputs: _Field_Interaccountingemail22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 2`)
};

const de__field_interaccountingemail22 = /** @type {(inputs: _Field_Interaccountingemail22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 2`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 2" |
*
* @param {_Field_Interaccountingemail22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_interaccountingemail22 = /** @type {((inputs?: _Field_Interaccountingemail22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interaccountingemail22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_interaccountingemail22(inputs)
	return de__field_interaccountingemail22(inputs)
});
export { _field_interaccountingemail22 as "_field_interAccountingEmail2" }